<div class="w-full h-full flex flex-col gap-4 md:gap-6 p-4 md:p-6 xl:p-7 overflow-auto">
    @if (isLoading) {
    <div class="flex flex-col justify-center items-center h-full gap-2">
        <div class="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-gray-900"></div>
        <span class="text-gray-700">Loading integrations...</span>
    </div>
    }@else {
    <!-- Search and Filter -->
    <div class="flex flex-col sm:flex-row justify-between items-stretch sm:items-center gap-3">
        <div class="relative w-full sm:w-64 md:w-80 lg:w-96 xl:w-[28.125rem]">
            <input type="text" [(ngModel)]="searchText" placeholder="Search integrations"
                class="w-full pl-10 pr-4 py-2.5 border border-gray-200 rounded-xl text-sm md:text-base focus:outline-none focus:border-blue-500">
            <i class="pi pi-search absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 text-base md:text-lg"></i>
        </div>
        <app-popover #filterPopover width="12rem">
            <ng-template #trigger>
                <button
                    class="flex items-center justify-center gap-2 px-3 md:px-4 py-2.5 border border-gray-200 rounded-xl bg-white shadow-sm hover:bg-gray-50 flex-shrink-0">
                    <i class="pi pi-filter text-sm text-gray-700"></i>
                    <span class="text-xs md:text-sm font-medium text-gray-700">Filters</span>
                </button>
            </ng-template>
            <ng-template #body>
                <div class="flex flex-col gap-3 p-1">
                    @for(option of filterOptions; track option.value) {
                    <app-checkbox [(value)]="option.checked" [config]="{ binary: true, label: option.label }">
                    </app-checkbox>
                    }
                </div>
            </ng-template>
        </app-popover>
    </div>

    @for (category of filteredCategories; track category.key) {
    <div class="flex flex-col gap-3 md:gap-4">
        <h2 class="text-base md:text-lg xl:text-xl font-semibold text-gray-900">{{category.title}}</h2>
        <div
            class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4 4xl:grid-cols-5 gap-4 md:gap-5 xl:gap-6">
            @for (card of category.items; track card.id) {
            <div class="bg-white border border-gray-200 rounded-lg md:rounded-xl p-4 md:p-5 shadow-sm hover:shadow-md transition-shadow cursor-pointer flex flex-col gap-3 md:gap-4 xl:gap-5"
                (click)="onIntegrationClick(card.value, category.key)">

                <div class="flex justify-between items-center gap-2">
                    <div class="px-2 py-1 rounded-md flex-shrink-0"
                        [ngClass]="isItemConnected(category, card) ? 'bg-green-100 text-green-700' : 'bg-red-50 text-red-600'">
                        <span class="text-xs md:text-sm font-medium whitespace-nowrap">
                            {{ isItemConnected(category, card) ? 'Connected' : 'Disconnected' }}
                        </span>
                    </div>
                    @if (category.hasToggle) {
                    <app-toggle [ngModel]="isItemConnected(category, card)"
                        (onChange)="onToggleChange(category, card.value, $event)" (click)="$event.stopPropagation()">
                    </app-toggle>
                    }
                </div>

                <div class="flex items-center gap-2 md:gap-3">
                    <div class="w-10 h-10 md:w-12 md:h-12 flex-shrink-0">
                        @if (card.imgSvgPath ) {
                        <div [innerHTML]="card.imgSvgPath | sanitizeHtml"
                            class="w-full h-full [&>svg]:w-full [&>svg]:h-full">
                        </div>
                        } @else {
                        <img [src]="(card.imgPath || '') | assetUrl" [alt]="card.name"
                            class="w-full h-full object-contain">
                        }
                    </div>
                    <h3 class="text-base md:text-lg font-semibold text-gray-900 break-words">{{card.name}}</h3>
                </div>

                <div class="flex justify-between items-center gap-2">
                    <p class="text-gray-500 text-sm md:text-base leading-relaxed break-words flex-1">
                        {{card.description}}
                    </p>
                    @if (category.showChevron) {
                    <i class="pi pi-chevron-right text-sm md:text-base leading-relaxed flex-shrink-0"></i>
                    }
                </div>
            </div>
            }
        </div>
    </div>
    }
    }


</div>

<app-dialog [(visible)]="showIntegrationDialog" [title]="integrationDialogConfig.title" class="max-w-[60vw]"
    [fullscreenOnMobile]="true">
    <ng-template #bodyTemplate>
        @if (currentIntegrationType === SIGNATORY_TYPE.DOCU_SIGN) {
        <app-docu-sign (close)="onDialogClose($event)"></app-docu-sign>
        } @else if (currentIntegrationType === SIGNATORY_TYPE.ADOBE_SIGN) {
        <app-adobe-sign (close)="onDialogClose($event)"></app-adobe-sign>
        } @else if (currentIntegrationType === 'MICROSOFT_AZURE') {
        <app-microsoft-azure (close)="onDialogClose($event)"></app-microsoft-azure>
        } @else {
        <app-default-integration-dialog [integration]="currentIntegrationData"
            (close)="onDialogClose($event)"></app-default-integration-dialog>
        }
    </ng-template>
</app-dialog>